module.exports = __webpack_public_path__ + "static/media/buttonred.28657611.png";